module.exports = __webpack_public_path__ + "static/scale-model-of-the-pioneer-spring-in-independence-missouri-692c96a01b7112ceff17610abfbdff34.png";